<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>活动投稿</el-breadcrumb-item>
          <el-breadcrumb-item>投稿图片筛选</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>
          投稿图片筛选
          <!-- <span
            style="font-size: 12px !important;margin-left:20px;color:rgb(96, 197, 255);cursor: pointer;"
          >查看送审给我的任务</span> -->
        </h4>
        <p @click="changeUserForm" :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">+创建筛选任务</p>
      </div>

      <div class="tabsbody">
        <el-tabs v-model="activeName"
                 type="border-card">
          <el-tab-pane name="0"
                       v-if="powersObj.manageAllPictureArticleFilter"
                       label="全部">
            <div style="height:650px;position: relative;"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <subpictable :tableData="userTableList"
                             @firstClick="firstClick"
                             @giveClick="giveClick"
                             @endClick="endClick"
                             @reviewClick="reviewClick"
                             @downloadClick="downloadClick"></subpictable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="currentPage"
                               :page-size="pageSize"
                               layout="prev, pager, next"
                               :total="total"></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="1"
                       v-if="powersObj.myPictureArticleFilter || powersObj.manageAllPictureArticleFilter"
                       label="我的创建">
            <div style="height:650px;position: relative;"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <subpictable :tableData="userMyTableList"
                             @firstClick="firstClick"
                             @giveClick="giveClick"
                             @endClick="endClick"
                             @reviewClick="reviewClick"
                             @downloadClick="downloadClick"></subpictable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChangeMy"
                               @current-change="handleCurrentChangeMy"
                               :current-page.sync="currentPageMy"
                               :page-size="pageSizeMy"
                               layout="prev, pager, next"
                               :total="totalMy"></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="2"
                       label="送审给我">
            <div style="height:650px;position: relative;"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <subpictable :tableData="userMyCheckTableList"
                             @firstClick="firstClick"
                             @giveClick="giveClick"
                             @endClick="endClick"
                             @reviewClick="reviewClick"
                             @downloadClick="downloadClick"></subpictable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChangeMyCheck"
                               @current-change="handleCurrentChangeMyCheck"
                               :current-page.sync="currentPageMyCheck"
                               :page-size="pageSizeMyCheck"
                               layout="prev, pager, next"
                               :total="totalMyCheck"></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

    <el-dialog :visible.sync="dialogVisibleCreate"
               width="26%"
               :before-close="handleCloseCreate">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>创建筛选任务</div>
      </div>
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="95px"
               class="demo-ruleForm"
               v-loading="dialogLoading">
        <el-form-item label="活动名:"
                      prop="name">
          <el-select :remote-method="remoteMethodAct"
                     filterable
                     @focus="setMinWidthAct"
                     v-model="ruleForm.name"
                     clearable
                     style="width:100%;"
                     placeholder="请选择活动名">
            <el-option v-for="item in actList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"
                       :style="{'max-width': minWidthAct + 2 + 'px'}"
                       v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务标题:"
                      prop="title">
          <el-input v-model="ruleForm.title"
                    placeholder="请输入任务标题"></el-input>
        </el-form-item>

        <el-form-item label="备注:"
                      prop="desc">
          <el-input type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12}"
                    v-model="ruleForm.desc"
                    placeholder="选填，备注不超过200个字"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button :disabled="dialogLoading"
                   @click="handleCloseCreate">取 消</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subCreate">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleGive"
               width="26%"
               :before-close="handleCloseGive"
               v-loading="giveLoading">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{giveName}}</div>
      </div>
      <el-form :model="ruleFormgive"
               :rules="rulesgive"
               ref="ruleFormgive"
               label-width="95px"
               class="demo-ruleForm"
               v-loading="dialogLoading"
               v-if="isGive">
        <el-form-item label="审核人:"
                      prop="name">
          <el-select @focus="setMinWidthExa"
                     v-model="ruleFormgive.name"
                     style="width:100%;"
                     placeholder="请选择一个审核人">

            <el-tooltip popper-class="atooltip"
                        v-for="item in exaList"
                        :key="item.value"
                        class="item"
                        effect="dark"
                        :content="'手机号:' + item.mobile + ' ; 邮箱:' + item.email"
                        placement="top-start">
              <el-option :label="item.label"
                         :value="item.value"
                         :style="{'width': minWidthExa + 2 + 'px'}"
                         @mouseenter.native="showexainfo(item)"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-tooltip>

          </el-select>
        </el-form-item>

        <el-form-item label="备注:"
                      prop="desc">
          <el-input type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12}"
                    v-model="ruleFormgive.desc"
                    placeholder="选填，备注不超过200个字"></el-input>
        </el-form-item>
      </el-form>

      <span v-if="isGive"
            slot="footer"
            class="dialog-footer">
        <el-button :disabled="dialogLoading"
                   @click="handleCloseGive">取 消</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subGive">提 交</el-button>
      </span>

      <div class="exa"
           v-if="!isGive">
        <div>PDF下载： <span>{{picPrefix + 'downloadPDF'}}</span> </div>
        <div class="erweima"
             id="erweima"
             style="width:200px;height:200px;margin:20px auto;"></div>
        <p>您可以将二维码发送给审核人进行在线审核</p>
        <p>此信息仅出现一次，请截图保存！</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { subpictable } from "@/components/index";
import { mapGetters } from "vuex";
import { picPrefix } from "@/constants/piccommon";
import {
  listPictureActivity
} from "@/api/pictureActivity";
import {
  listUser, getUser
} from "@/api/user";
import {
  addTask,
  toCheck,
  listTask,
  setTaskStatus,
  listCheckUser,
  listSelect
} from "@/api/workflow";
import { getDate, formatConversion } from "@/plugins/getdate";
import QRCode from 'qrcodejs2'  // 引入qrcode
import { powersObj } from "@/constants/powers";
export default {
  components: {
    subpictable,
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      activeName: '0',
      //权限
      powersObj,
      roleName: [],
      myroleIds: [],
      picPrefix,
      pictureArticleFilterTaskId: 0,

      //送审相关
      giveLoading: false,
      giveName: '送审',
      isGive: true,
      dialogVisibleGive: false,
      exaList: [],
      ruleFormgive: {
        name: "",
        desc: "",
      },
      rulesgive: {
        name: [{ required: true, message: "请选择审核人", trigger: "change" }],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur",
          },
        ],
      },

      //创建任务
      dialogLoading: false,
      actList: [],
      ruleForm: {
        name: "",
        title: "",
        desc: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入任务标题", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请选择活动名", trigger: "change" }],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur",
          },
        ],
      },

      total: 0,
      currentPage: 1,
      pageSize: 10,
      //所有任务列表
      userTableList: [],


      totalMy: 0,
      currentPageMy: 1,
      pageSizeMy: 10,
      //我的任务列表
      userMyTableList: [],

      totalMyCheck: 0,
      currentPageMyCheck: 1,
      pageSizeMyCheck: 10,
      //我的审核任务列表
      userMyCheckTableList: [],

      dialogVisibleCreate: false,

      timeInt: "",
      isRefresh: false,
      minWidthAct: 362,
      minWidthExa: 364,
    };
  },
  methods: {
    //查看审核人详细信息
    showexainfo (e) {
      console.log(1);
    },
    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data = { page: this.currentPage - 1, pageSize: this.pageSize - 5, createUid: this.createUid };
      // console.log(data)
      this.listTaskAsync(data)
    },

    //我的
    handleSizeChangeMy (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChangeMy (val) {
      this.currentPageMy = val;
      let data = { page: this.currentPageMy - 1, pageSize: this.pageSizeMy, createUid: this.createUid };
      // console.log(data)
      this.listMyTaskAsync(data)
    },

    //送审我的
    handleSizeChangeMyCheck (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChangeMyCheck (val) {
      this.currentPageMyCheck = val;
      let data = { page: this.currentPageMyCheck - 1, pageSize: this.pageSizeMyCheck, currentUid: this.createUid, status: 2 };
      // console.log(data)
      this.listMyCheckTaskAsync(data)
    },


    //刷新表格
    refresh () {
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      this.handleCurrentChangeMy(this.currentPageMy);
      this.handleCurrentChangeMyCheck(this.currentPageMyCheck);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },



    changeUserForm () {
      this.dialogVisibleCreate = true
    },
    //roleform关闭窗口事件
    closeForm () {

    },

    //roleform提交表单事件
    submitForm (data) {
      this.addThemeAsync(data);
    },

    firstClick (val) {
      this.$router.push({ path: '/workflow/screenPic', query: { name: val.row.title, id: val.row.pictureActivityId, pictureArticleFilterTaskId: val.row.id, activeSteps: 0 } })
      let data = { id: val.row.id, status: 1 }
      this.setTaskStatusAsync(data)
    },
    async giveClick (val) {
      console.log(val)
      let { status, data, message, pagination } = await listSelect({
        pictureArticleFilterTaskId: val.row.id
      });
      if (pagination.total > 0) {
        this.dialogVisibleGive = true
        this.pictureArticleFilterTaskId = val.row.id
      } else {
        this.$message.warning('您暂未初选图片！')
      }

    },
    endClick (val) {
      this.$confirm("确认结束吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let data = { id: val.row.id, status: 3 }
          this.setTaskStatusAsync(data)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },
    downloadClick (val) {
      this.$router.push({
        path: '/workflow/screenPic',
        query: {
          name: val.row.title,
          id: val.row.pictureActivityId,
          pictureArticleFilterTaskId: val.row.id,
          activeSteps: 2,
          currentUsername: val.row.currentUsername
        }
      })
    },

    //送审相关

    //改变用户option宽度
    remoteMethodExa (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: (this.currentPage - 1), pageSize: this.pageSize, keyword: query }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { page: (this.currentPage - 1), pageSize: this.pageSize }
        this.listUserAsync(dataExa)
      }
    },
    setMinWidthExa (val) {
      this.minWidthExa = val.srcElement.clientWidth
    },
    handleCloseGive () {
      this.dialogVisibleGive = false;
      this.$refs["ruleFormgive"].resetFields();
      this.handleCurrentChange(this.currentPage);
    },
    subGive () {
      this.$refs["ruleFormgive"].validate(valid => {
        if (valid) {
          this.giveLoading = true
          let data = {
            message: this.ruleFormgive.desc,
            pictureArticleFilterTaskId: this.pictureArticleFilterTaskId,
            targetUid: this.ruleFormgive.name
          }
          this.toCheckAsync(data)

          // this.addAtlasAsync(data);
        }
      })
    },

    //复审相关
    reviewClick (val) {
      this.$router.push({
        path: '/workflow/screenPic',
        query: {
          name: val.row.title,
          id: val.row.pictureActivityId,
          pictureArticleFilterTaskId: val.row.id,
          activeSteps: 1,
          currentUsername: val.row.currentUsername
        }
      })
    },

    //创建任务

    //活动检索
    remoteMethodAct (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: (this.currentPage - 1), pageSize: this.pageSize, createUid: -1, keyword: query }
        this.listPictureActivityAsync(dataExa)
      } else {
        dataExa = { page: (this.currentPage - 1), createUid: -1, pageSize: this.pageSize }
        this.listPictureActivityAsync(dataExa)
      }
    },
    //改变活动option宽度
    setMinWidthAct (val) {
      this.minWidthAct = val.srcElement.clientWidth
    },
    handleCloseCreate () {
      this.dialogVisibleCreate = false;
      this.$refs["ruleForm"].resetFields();
    },
    subCreate () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.dialogLoading = true;
          let data = {
            createUid: this.createUid,
            desc: this.ruleForm.desc,
            title: this.ruleForm.title,
            pictureActivityId: this.ruleForm.name,
            status: 0
          };
          // console.log(data)
          this.addTaskAsync(data);
        }
      })
    },

    dialogSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.myform.newpsw) {
            this.myform.password = this.$md5(this.myform.newpsw);
          }
          this.myform.roleIds = "";
          for (let i = 0; i < this.myroleIds.length; i++) {
            if (i === this.myroleIds.length - 1) {
              this.myform.roleIds += this.myroleIds[i];
            } else {
              this.myform.roleIds += this.myroleIds[i] + ",";
            }
          }
          this.updateUserAsync(this.myform);
        } else {
          return false;
        }
      });
    },
    //修改用户
    reviseClick (scope) {
      this.getThemeAsync(scope.row.id);
    },

    //停用或开启用户
    closeClick (val) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let closeMsg = val.row;
          if (closeMsg.status === 0) {
            closeMsg.status = 1;
          } else {
            closeMsg.status = 0;
          }
          this.updateThemeAsync(closeMsg);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },


    //送审
    async toCheckAsync (val) {
      let { status, data, message, errors } = await toCheck(
        val
      );
      if (status) {
        let data = { id: this.pictureArticleFilterTaskId, status: 2 }
        this.setTaskStatusAsync(data)
        this.$message.success('送审成功！')
        this.giveName = '审核信息';
        this.isGive = false
        setTimeout(() => {
          let qrcode = new QRCode('erweima', {
            width: 200,
            height: 200,
            // text: 'http://localhost:8080/' + 'mobileworkflow/check' + "?token="+ localStorage.getItem('token').replace("\"","").replace("\"","") + '&id=' + this.pictureArticleFilterTaskId, // 二维码地址
            text: picPrefix + 'mobileWorkflow/check' + "?token=" + localStorage.getItem('token').replace("\"", "").replace("\"", "") + '&id=' + this.pictureArticleFilterTaskId, // 二维码地址
          })
          this.giveLoading = false
        }, 100);


      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.giveLoading = false
      }
    },
    //设置任务状态
    async setTaskStatusAsync (val) {
      let { status, data, message } = await setTaskStatus(
        val
      );
      if (status) {
        this.handleCurrentChange(this.currentPage);
        this.handleCurrentChangeMy(this.currentPageMy);
        this.handleCurrentChangeMyCheck(this.currentPageMyCheck);
      }
    },

    //获取征稿活动列表
    async listPictureActivityAsync (val) {
      let { status, data, message, pagination, errors } = await listPictureActivity(
        val
      );
      if (status) {
        this.actList = []
        for (let i = 0; i < data.length; i++) {
          this.actList.push({
            value: data[i].id,
            label: data[i].title,
          })

        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取用户列表
    async listCheckUserAsync (val) {
      let { status, data, message, pagination } = await listCheckUser(
        val
      );
      if (status) {
        this.exaList = []
        for (let i = 0; i < data.length; i++) {
          let userInfo = await getUser(data[i].uid)
          if (userInfo.status) {
            if (userInfo.data.status == 1) {
              this.exaList.push({
                value: userInfo.data.id,
                label: userInfo.data.name,
                mobile: userInfo.data.mobile,
                email: userInfo.data.email,
              })
            }

          }



        }
      }
    },
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, pagination, errors } = await listUser(
        val
      );
      if (status) {
        this.exaList = []
        for (let i = 0; i < data.length; i++) {
          this.exaList.push({
            value: data[i].id,
            label: data[i].name,
          })

        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取任务列表
    async listTaskAsync (val) {
      let { status, data, message, pagination } = await listTask(val);
      if (status) {
        let myCurrentUidList = await listTask({ page: this.currentPage - 1, pageSize: this.pageSize - 4, currentUid: this.createUid });
        this.total = pagination.total
        this.userTableList = data

        for (let i = 0; i < myCurrentUidList.data.length; i++) {
          if (myCurrentUidList.data[i].createUserInfo.id !== myCurrentUidList.data[i].currentUserInfo.id) {
            this.userTableList.push(myCurrentUidList.data[i])
          }

        }

        // if(myCurrentUidList.data.length > 0){
        //   for (let i = 0; i < myCurrentUidList.data.length; i++) {
        //     for (let j = 0; j < data.length; j++) {
        //       if(data[j].id !== myCurrentUidList.data[i].id){
        //         this.userTableList.push(myCurrentUidList.data[i])
        //       }
        //     }

        //   }
        // }
        this.total += myCurrentUidList.pagination.total

        for (let i = 0; i < this.userTableList.length; i++) {
          this.userTableList[i].activityName = this.userTableList[i].activityInfo.title
          this.userTableList[i].createUserName = this.userTableList[i].createUserInfo.name
          this.userTableList[i].currentUsername = this.userTableList[i].currentUserInfo.name
        }
      }
    },


    //我的
    async listMyTaskAsync (val) {
      let { status, data, message, pagination } = await listTask(val);
      if (status) {
        this.totalMy = pagination.total
        this.userMyTableList = data
        for (let i = 0; i < this.userMyTableList.length; i++) {
          this.userMyTableList[i].activityName = this.userMyTableList[i].activityInfo.title
          this.userMyTableList[i].createUserName = this.userMyTableList[i].createUserInfo.name
          this.userMyTableList[i].currentUsername = this.userMyTableList[i].currentUserInfo.name
        }
      }
    },

    //送审我的
    async listMyCheckTaskAsync (val) {
      let { status, data, message, pagination } = await listTask(val);
      if (status) {
        this.totalMyCheck = pagination.total
        this.userMyCheckTableList = data
        for (let i = 0; i < this.userMyCheckTableList.length; i++) {
          this.userMyCheckTableList[i].activityName = this.userMyCheckTableList[i].activityInfo.title
          this.userMyCheckTableList[i].createUserName = this.userMyCheckTableList[i].createUserInfo.name
          this.userMyCheckTableList[i].currentUsername = this.userMyCheckTableList[i].currentUserInfo.name
        }
      }
    },

    //删除活动主题
    async deleteThemeAsync (val) {
      // let { status, data, message } = await deleteTheme(val);
      if (status) {
      }
    },

    //修改活动主题信息
    async updateThemeAsync (val) {
      // let { status, data, message,errors } = await updateTheme(val);
      if (status) {
      }
    },

    //增加活动主题
    async addTaskAsync (val) {
      let { status, data, message, errors } = await addTask(val);
      if (status) {
        this.$message.success('创建成功！')
        this.handleCloseCreate()
        this.handleCurrentChange(this.currentPage);
        this.dialogLoading = false;
      } else {
        this.$message.error(message)
        this.dialogLoading = false;
      }

    },
  },
  created () {
    let dataAct = { page: (this.currentPage - 1), pageSize: this.pageSize, createUid: -1 }
    this.listPictureActivityAsync(dataAct)

    // let dataExa = {page:(this.currentPage - 1),pageSize:this.pageSize}
    // this.listUserAsync(dataExa)

    this.listCheckUserAsync()

    if (this.$route.query) {
      this.activeName = this.$route.query.id
    }
    this.handleCurrentChange(this.currentPage);
    this.handleCurrentChangeMy(this.currentPageMy);
    this.handleCurrentChangeMyCheck(this.currentPageMyCheck);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
      this.handleCurrentChangeMy(this.currentPageMy);
      this.handleCurrentChangeMyCheck(this.currentPageMyCheck);
    }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    clearTimeout(this.timeInt);
  },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./subpicmanager.scss";
@import "@/constants/elHeader.scss";
.pagination {
  position: absolute;
  right: 30px;
  bottom: 30px;
}
</style>
<style>
.atooltip {
  z-index: 9999999 !important;
}
</style>